import { useRef } from 'react';
export function useMemoize(fn, hasher) {
  const cacheRef = useRef(new Map());
  return (...args) => {
    const key = hasher(...args);
    if (!cacheRef.current.has(key)) {
      cacheRef.current.set(key, fn(...args));
    }
    return cacheRef.current.get(key);
  };
}